<p>Información Del Bono Aqui</p>
<button (click)="closeModal()">
Cancelar
</button>
